import React from 'react';
import TutorialSlide from './TutorialSlide';

const Tutorial = () => {
  return (
    <div className="App">
      <TutorialSlide />
    </div>
  );
}

export default Tutorial;
